import { render, staticRenderFns } from "./corporateApprovalTable.vue?vue&type=template&id=119a3b2f&"
import script from "./corporateApprovalTable.vue?vue&type=script&lang=js&"
export * from "./corporateApprovalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports